import { IAuthenticationRegistry, IAuthenticationService } from "../../domain/authentication";
import { AuthenticationService, AuthenticationRepository } from ".";

export class AuthenticationRegistry implements IAuthenticationRegistry {
  constructor(getToken: () => string) {
    this._service = new AuthenticationService(new AuthenticationRepository(getToken));
  }

  private readonly _service: IAuthenticationService;

  getAuthenticationService(): IAuthenticationService {
    return this._service;
  }
}
